import React from 'react';
import { TextButton } from 'library';
import { useHistory } from 'react-router';
import { ITeacher } from 'models';

export default function ViewMoreTeachers({ showcaseWorkers }: { showcaseWorkers?: ITeacher[] }) {
    const history = useHistory();
    return (
        <TextButton
            onClick={() =>
                history.push({ pathname: '/teacher-showcase', state: { showcaseWorkers: showcaseWorkers ?? [] } })
            }
            buttonStyle={{ width: 'auto' }}
        >
            View More Teachers
        </TextButton>
    );
}
